export default __webpack_public_path__ + "static/media/polyester.b5a5402a.webp";